<template>
  <a-card :bordered="false" class="pcConfig">
    <bannerModule></bannerModule>
  </a-card>
</template>
<script>
import bannerModule from './module/bannerModule.vue';
export default {
  components: {
    bannerModule,
  },
};
</script>

<style scoped>
.pcConfig {
  height: 100%;
  overflow: auto;
}
</style>
